export default "__VITE_ASSET__Bs3rMoLf__"